import { FeatureForm } from '../components/FeatureForm';



export const SubmitFeature = () => {
  return <FeatureForm />;
};
